import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { campaignsApi, type Campaign } from '../campaignsApi';
import { campaignGoogleProposals } from '../googleProposals';

interface Props { campaign: Campaign; init?: RequestInit }

export function GoogleActivePublication({ campaign, init }: Props) {
  const [reviewing, setReviewing] = useState(false);
  const queryClient = useQueryClient();
  const assets = campaignGoogleProposals(campaign);
  const mutation = useMutation({
    mutationFn: () => campaignsApi.syncGoogleAds(campaign.id, { autoActivate: false }, init),
    onSuccess: () => {
      setReviewing(false);
      queryClient.invalidateQueries({ queryKey: ['campaign', campaign.id] });
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
    },
  });
  const ready = assets.headlines.length >= 3 && assets.descriptions.length >= 2 && assets.keywords.length > 0;
  return <div className="campaign-search-preview">
    <strong>Atualizar publicação existente no Google Ads</strong>
    <p>Conta: {campaign.google_customer_id} · Campanha: {campaign.google_campaign_id}</p>
    <p>Envia os textos e a URL revisados acima. Insere palavras-chave ausentes, reativa as selecionadas e pausa as positivas que saíram da lista neste grupo. Preserva palavras negativas, status de veiculação e orçamento.</p>
    {reviewing ? <>
      <p>{assets.headlines.length} títulos · {assets.descriptions.length} descrições · {assets.keywords.length} palavras-chave. O Google poderá revisar novamente o anúncio.</p>
      <div className="google-proposal-actions">
        <button type="button" className="campaign-journey-button" disabled={mutation.isPending || !ready}
          onClick={() => mutation.mutate()}>{mutation.isPending ? 'Enviando ao Google Ads...' : 'Confirmar envio do conteúdo revisado'}</button>
        <button type="button" className="google-proposal-secondary" disabled={mutation.isPending}
          onClick={() => setReviewing(false)}>Cancelar envio</button>
      </div>
    </> : <button type="button" className="campaign-journey-button" disabled={!ready}
      onClick={() => { mutation.reset(); setReviewing(true); }}>Revisar e reenviar ao Google Ads</button>}
    {mutation.error && <p role="alert" className="campaign-channel-error">Não foi possível atualizar: {mutation.error.message}</p>}
    {mutation.isSuccess && <p role="status">Conteúdo enviado ao Google Ads. A veiculação depende da análise e elegibilidade na origem.</p>}
  </div>;
}
